var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerateStyleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.2L12 3L21 8.2V21H15H11.9H10.874C11.5826 20.0149 12 18.8062 12 17.5C12 14.1863 9.31371 11.5 6 11.5C4.90714 11.5 3.88252 11.7922 3 12.3027V8.2ZM8.8 11H15V9H8.8V11Z",
    fill: "black",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99996 12L8.24996 14.25L5.99996 16.5V15C4.14996 15 2.93996 16.96 3.75996 18.62L2.66996 19.71C0.909959 17.05 2.80996 13.5 5.99996 13.5V12ZM5.99996 23L3.74996 20.75L5.99996 18.5V20C7.84996 20 9.05996 18.04 8.23996 16.38L9.32996 15.29C11.09 17.95 9.18996 21.5 5.99996 21.5V23Z",
    fill: "black",
    fillOpacity: 0.54
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateStyleIcon);
export default __webpack_public_path__ + "static/media/generateStyleIcon.5a1f009506a017eace2618b7b5780e7b.svg";
export { ForwardRef as ReactComponent };